import mockAxios, { AxiosResponse } from 'axios';

import { IPayrollChangeRequestServiceMock } from './payrollchangerequest.mock.types';

export const mockPayrollChangeRequestService = (): IPayrollChangeRequestServiceMock => ({
  fetchPayrollChangeRequests: jest.fn(),
  fetchPayrollChangeRequest: jest.fn(),
  createPayrollChangeRequest: jest.fn(),
  updatePayrollChangeRequest: jest.fn(),
  deletePayrollChangeRequest: jest.fn(),
  updatePayrollChangeRequestState: jest.fn(),

  fetchPayrollChangeRequestActivities: jest.fn(),
  fetchPayrollChangeRequestHRPersonnels: jest.fn(),

  //export
  exportPayrollChangeRequestPdf: jest.fn()
});

export const mockPayrollChangeRequestAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
